// extracted by mini-css-extract-plugin
export default {"emailConfirmPage":"style_emailConfirmPage__LqGu+","emailConfirmInner":"style_emailConfirmInner__OvMnT","successBox":"style_successBox__vX6g5"};